import * as React from 'react';
import { SVGProps } from 'react';

const IconFileTableSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 4.5h20v15H2v-15Zm1 1v1h8v-1H3Zm9 0v1h4v-1h-4Zm5 0v1h4v-1h-4Zm4 2h-4v3h4v-3Zm0 4h-4v3h4v-3Zm0 4h-4v3h4v-3Zm-5 3v-3h-4v3h4Zm-5 0v-3H3v3h8Zm-8-4h8v-3H3v3Zm0-4h8v-3H3v3Zm9-3v3h4v-3h-4Zm4 4h-4v3h4v-3Z"
    />
  </svg>
);
export default IconFileTableSizeM;
